export default __webpack_public_path__ + "static/Image20@2x-99629496f44f39f4ab2156ffb110779e.png";